module.exports = __webpack_public_path__ + "gift-logo.f7a5911c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/theme/svg/gift-logo.svg
// module id = 576
// module chunks = 1